import React, { useState } from 'react'
import { Button } from 'react-bootstrap'
import { requestToJoinTeam } from 'services/manage'
import styles from './SelectTeamOwner.module.css'

const SelectTeamOwner = ({ teamOwners, onHide, onSuccess }) => {
  const [loadingStates, setLoadingStates] = useState({})
  const [errorMessage, setErrorMessage] = useState('')

  const getButtonText = (owner) => {
    const isLoading = loadingStates[owner.email]

    if (isLoading) return 'Requesting...'
    if (owner.requestStatus === 'pending') return 'Request sent'
    if (owner.requestStatus === 'denied') return 'Request denied'
    return 'Request to join'
  }

  const handleRequestToJoin = async (ownerEmail) => {
    setErrorMessage('')
    setLoadingStates((prev) => ({ ...prev, [ownerEmail]: true }))

    try {
      await requestToJoinTeam(ownerEmail)
      onSuccess(ownerEmail)
    } catch (error) {
      console.error('Failed to request team join:', error)
      setErrorMessage('Failed to send request. Please try again.')
    } finally {
      setLoadingStates((prev) => ({ ...prev, [ownerEmail]: false }))
    }
  }

  return (
    <div className="p-4">
      <h2 className="mb-2 bold color-purple-2 font-22">Choose team owner</h2>
      <div className="grey mb-4">Select which team owner you&apos;d like to send your join request to.</div>

      {errorMessage && <div className={styles.errorMessage}>{errorMessage}</div>}

      <div className={styles.teamOwnersList}>
        {teamOwners.map((owner) => {
          const buttonText = getButtonText(owner)

          return (
            <div key={owner.email} className={styles.teamOwnerItem}>
              <div className={styles.ownerInfo}>
                <div className={styles.ownerIcon}>
                  <img src="/assets/icons/team.svg" width="20" height="20" alt="Team owner" />
                </div>
                <div className={styles.ownerDetails}>
                  <div className={styles.ownerEmail}>{owner.email}</div>
                  <div className={styles.ownerDescription}>
                    {owner.name || 'Pro account holder with your company domain'}
                  </div>
                  {owner.requestStatus === 'pending' && (
                    <div className={styles.statusBadge}>
                      <span className={styles.pendingBadge}>Request sent - pending approval</span>
                    </div>
                  )}
                  {owner.requestStatus === 'denied' && (
                    <div className={styles.statusBadge}>
                      <span className={styles.deniedBadge}>Request denied</span>
                    </div>
                  )}
                </div>
              </div>
              <Button
                variant={owner.requestStatus === 'pending' ? 'outline-secondary' : 'primary'}
                size="sm"
                onClick={() => handleRequestToJoin(owner.email)}
                disabled={loadingStates[owner.email]}
                className={styles.requestButton}
              >
                {buttonText}
              </Button>
            </div>
          )
        })}
      </div>

      <div className={styles.infoSection}>
        <img src="/assets/icons/info-grey.svg" height="12" className="me-2" alt="info" />
        <span className={styles.infoText}>
          The team owner will receive an email notification about your request to join their team.
        </span>
      </div>

      <div className="d-flex justify-content-end mt-4">
        <Button variant="outline-secondary" onClick={onHide}>
          Cancel
        </Button>
      </div>
    </div>
  )
}

export default SelectTeamOwner
